import { render, staticRenderFns } from "./LiveAccountDetails.vue?vue&type=template&id=71408426&scoped=true"
import script from "./LiveAccountDetails.vue?vue&type=script&lang=js"
export * from "./LiveAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./LiveAccountDetails.vue?vue&type=style&index=0&id=71408426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71408426",
  null
  
)

export default component.exports